import { motion } from "framer-motion";
import { Cloud, Sparkles, Microscope, BookOpen, Clapperboard, Code2, LayoutGrid } from "lucide-react";
import { SectionHeader } from "./SectionHeader";

const features = [
  {
    icon: Cloud,
    title: "5TB Cloud Storage",
    desc: "Ruang penyimpanan raksasa untuk semua kebutuhan Anda — hingga 5TB.",
    chips: ["Google Drive", "Gmail", "Google Photos"],
    span: "lg:col-span-2",
    gradient: "from-sky-50 to-blue-50",
  },
  {
    icon: Sparkles,
    title: "Gemini 3.1 Pro",
    desc: "AI paling canggih dari Google untuk pekerjaan berat sehari-hari.",
    chips: ["Brainstorming", "Coding", "Research", "Reasoning"],
    span: "",
    gradient: "from-indigo-50 to-violet-50",
  },
  {
    icon: Microscope,
    title: "Deep Research",
    desc: "Riset otomatis mendalam lengkap dengan sumber terpercaya.",
    chips: ["Ringkasan", "Analisa", "Referensi", "Laporan"],
    span: "",
    gradient: "from-rose-50 to-orange-50",
  },
  {
    icon: BookOpen,
    title: "NotebookLM Premium",
    desc: "Upload dokumen apa pun — AI merangkum semuanya secara otomatis.",
    chips: ["PDF", "Jurnal", "Skripsi", "Buku"],
    span: "",
    gradient: "from-amber-50 to-yellow-50",
  },
  {
    icon: Clapperboard,
    title: "Flow AI Video",
    desc: "Dapatkan kredit Flow AI Video untuk membuat video AI berkualitas tinggi.",
    chips: ["Video AI Premium", "Kredit Termasuk"],
    span: "",
    gradient: "from-cyan-50 to-teal-50",
  },
  {
    icon: Code2,
    title: "Coding Assistant",
    desc: "Partner ngoding 24 jam yang paham seluruh codebase Anda.",
    chips: ["Debug", "Generate Code", "Refactor", "Explain Code"],
    span: "",
    gradient: "from-violet-50 to-purple-50",
  },
  {
    icon: LayoutGrid,
    title: "Workspace AI",
    desc: "Seluruh aplikasi Google favorit Anda kini terintegrasi AI.",
    chips: ["Google Docs", "Google Sheets", "Google Slides", "Google Meet", "Gmail"],
    span: "lg:col-span-2",
    gradient: "from-emerald-50 to-green-50",
  },
];

export const Features = () => (
  <section className="py-20 md:py-28 bg-white" id="fitur">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <SectionHeader
        title="Semua yang Anda dapatkan dalam satu paket Pro."
        sub="Paket Pro penuh dengan seluruh ekosistem AI Google — siap dipakai untuk kuliah, kerja, konten, dan bisnis Anda."
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {features.map(({ icon: Icon, title, desc, chips, span, gradient }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className={`rounded-3xl bg-gradient-to-br ${gradient} border border-slate-200/70 p-7 md:p-8 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(37,99,235,0.12)] transition-[transform,box-shadow] duration-300 ${span}`}
            data-testid={`feature-card-${i}`}
          >
            <span className="inline-flex w-12 h-12 rounded-2xl bg-white shadow-[0_4px_16px_rgba(0,0,0,0.06)] items-center justify-center">
              <Icon className="w-6 h-6 text-blue-600" strokeWidth={2.2} />
            </span>
            <h3 className="mt-5 font-heading font-extrabold text-xl text-slate-900">{title}</h3>
            <p className="mt-2 text-slate-600 leading-relaxed text-sm md:text-base">{desc}</p>
            <div className="flex flex-wrap gap-2 mt-4">
              {chips.map((chip) => (
                <span key={chip} className="rounded-full bg-white/90 border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700">
                  {chip}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
